import React from 'react';
import { useParams } from 'react-router';

import { ICONS } from '@/src/components/common/Elements/Icon/Icon';
import { useLogActivity } from '@/src/components/project/Inbox2/api/logActivity';
import ActionButton from '@/src/components/project/Inbox2/Elements/ActionButton/ActionButton';
import { getEmailEnryViewerPageUrl } from '@/src/components/project/Inbox2/pages/InboxEntryViewerPage/EmailEntryViewerPage/EmailEntryViewerPage';
import { EmailEntry } from '@/src/components/project/Inbox2/types';
import { showToast } from '@/src/globalFunction';
import { queryClient } from '@/src/lib/react-query/react-query';

import { acivityLogsKeys } from '../../../../api/getActivityLogs';

type CopyEmailUrlProps = {
  selectedEmailEntry: EmailEntry;
};

const CopyEmailUrl = ({ selectedEmailEntry }: CopyEmailUrlProps) => {
  const { projectId } = useParams<{ projectId: string }>();
  const logActivityMutation = useLogActivity();

  const handleClick = async () => {
    const documentUrl = getEmailEnryViewerPageUrl({
      projectId,
      emailId: `${selectedEmailEntry.id}`,
      inboxEntryId: selectedEmailEntry.inboxEntryId,
    });
    const data = [
      {
        linkId: selectedEmailEntry.id,
        linkType: 'inbox-email',
        title: `copied Email URL of`,
        actionType: 'copy',
        projectId: projectId,
        activity: `Copied Email URL`,
      },
    ];

    navigator.clipboard.writeText(documentUrl);

    const response = await logActivityMutation.mutateAsync({
      data,
      type: 'file',
    });

    if (response) {
      queryClient.invalidateQueries([
        ...acivityLogsKeys.detail({
          projectId,
          emailId: selectedEmailEntry.id,
          inboxEntryId: selectedEmailEntry.inboxEntryId,
        }),
      ]);
      showToast('success', 'File link copied to clipboard.');
    }
  };

  return (
    <ActionButton
      id={'copy_url'}
      onClick={handleClick}
      tooltipSettings={{
        content: 'Copy Email URL',
        place: 'left',
      }}
      icon={ICONS.link}
    />
  );
};

export default CopyEmailUrl;
